import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderOpenFront: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFolderOpenFront"><Path d="M2.5 10V3.5H9.88889L12 5.5H21.5V10" stroke="currentColor"/><Path d="M23.2473 11.5H0.748047L2.49924 19.5H21.4992L23.2473 11.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconFolderOpenFront;
